import React, { useEffect, useState } from 'react';
import { getSumarioExecutivo, updateSumarioExecutivo } from '@app/api/demanda';
import { Collapse, Icon } from 'antd';
import {
  Col,
  CompositeView,
  FormatText,
  FormInput,
  FormSelect,
  FormSubmitButton,
  FormTextArea,
  GridView,
  MasterDetailForm,
  Row,
  SimpleView,
  useRouter,
  Widget,
} from '@digital/ui';

const { Panel } = Collapse;

const SumarioExecutivo = () => {
  const { match } = useRouter();
  const [id, setId] = useState<string | null>(match.url.split('/')[3] ? match.url.split('/')[3] : null);
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState();

  const onUpdate = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    if (id) {
      getSumarioExecutivo(id).then(data => {
        if (data) {
          setData(data);
        }
      });
    }
  }, [id, update]);

  const handleSubmit = (values, widget) => {
    updateSumarioExecutivo(values, widget).then(data => {
      if (data) {
        onUpdate();
      }
    });
  };

  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <Collapse defaultActiveKey={['ces']} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Contract Executive Summary - CES" key="ces">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'ces')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Row>
                    <FormInput name="type" label="Type" span={2} />
                    <FormInput name="issuedToBod" label="Issued to BoD" span={2} />
                    <FormInput name="approvalPlanned" label="Approval Planned" span={2} />
                    <FormInput name="contract" label="Contract" span={1} />
                    <FormInput name="contractName" label=" " span={3} />
                  </Row>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Contract Details" key="details">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'details')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Row>
                    <FormInput name="object" label="Object" span={12} />
                    <FormInput name="businessNeed" label="Business Need" span={12} />
                    <FormInput name="contractor" label="Contractor" span={12} />
                  </Row>
                  <fieldset>
                    <legend>MRN Management</legend>
                    <Row>
                      <FormInput name="contractManager" label="Contract Manager" span={4} />
                      <FormInput name="totalValue" label="Total Value" span={4} />
                      <FormInput name="forecastCurrentYear" label="Forecast (current year)" span={4} />
                    </Row>
                    <Row>
                      <FormInput name="areaDepartment" label="Area & Department" span={4} />
                      <FormInput name="multiannualContract" label="Multiannual Contract" span={4} />
                      <FormInput name="expenseType" label="Expense type" span={4} />
                    </Row>
                    <Row>
                      <FormInput name="umbrellaContract" label="Umbrella Contract" span={4} />
                      <FormInput name="budgetCurrentYear" label="Budget (current year)" span={4} />
                    </Row>
                  </fieldset>
                  <fieldset>
                    <legend>Other Info</legend>
                    <Row>
                      <FormInput name="contractType" label="Contract Type" span={4} />
                      <FormInput name="sla" label="SLA" span={4} />
                      <FormInput name="mobilizationFee" label="Mobilization Fee" span={4} />
                    </Row>
                    <Row>
                      <FormInput name="modality" label="Modality" span={4} />
                      <FormInput name="insurances" label="Insurances" span={4} />
                      <FormInput name="location" label="Location" span={4} />
                    </Row>
                    <Row>
                      <FormInput name="exitClauses" label="Exit Clauses" span={4} />
                      <FormInput name="guarantee" label="Guarantee" span={4} />
                    </Row>
                    <Row>
                      <FormInput name="priceAdjustment" label="Price Adjustment" span={4} />
                      <FormInput name="downPayment" label="Down Payment" span={4} />
                    </Row>
                  </fieldset>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Bidding Process" key="bidding">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'bidding')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Row>
                    <FormInput label="Tendering" name="tendering" span={2} />
                    <FormInput label="Vendor List" name="vendorList" span={2} />
                    <FormInput label="Sub Techinical" name="subTechinical" span={2} />
                    <FormInput label="Sub. Commercial" name="subCommercial" span={2} />
                    <FormInput label="Max." name="max" span={1} />
                    <FormInput label="Min." name="min" span={1} />
                    <FormInput label="Selected" name="selected" span={2} />
                  </Row>
                  <Row>
                    <FormInput name="amendment" label="Amendment" span={2} />
                    <FormInput name="amendmentDescription" label="Description" span={8} />
                    <FormInput name="amendmentCost" label="Cost Var." span={2} />
                  </Row>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Execution" key="execution">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'execution')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Col span={6}>
                    <fieldset>
                      <legend>Schedule</legend>
                      <Row>
                        <FormInput name="commencement" label="Commencement" span={5} />
                        <FormInput name="termination" label="Termination" span={5} />
                        <FormInput name="duration" label="Duration" span={2} />
                      </Row>
                      <Row>
                        <FormInput name="additionalInfo" label="Additional Info" span={12} />
                      </Row>
                    </fieldset>
                  </Col>
                  <Col span={6}>
                    <fieldset style={{ marginTop: '0', paddingTop: '0' }}>
                      <legend>Resources & Take-Off</legend>
                      <Row>
                        <FormInput name="directLabor" label="Direct Labor" span={6} />
                        <FormInput name="hydraulicExcavator" label="Hydraulic Excavator" span={6} />
                      </Row>
                      <Row>
                        <FormInput name="indirectLabor" label="Indirect Labor" span={6} />
                        <FormInput name="wheelLoader" label="Wheel Loader" span={6} />
                      </Row>
                      <Row>
                        <FormInput name="tiltDumpTrucks" label="Tilt/Dump Trucks" span={6} />
                        <FormInput name="tractor" label="Tractor" span={6} />
                      </Row>
                      <Row>
                        <FormInput name="waterTruck" label="Water Truck" span={6} />
                        <FormInput name="crawlerTractor" label="Crawler Tractor" span={6} />
                      </Row>
                    </fieldset>
                  </Col>
                  <fieldset>
                    <legend>Summarized SWOT</legend>
                    <Row>
                      <FormInput name="strength" label="Strength" span={12} />
                    </Row>
                    <Row>
                      <FormInput name="weaknesses" label="Weaknesses" span={12} />
                    </Row>
                    <Row>
                      <FormInput name="opportunities" label="Opportunities" span={12} />
                    </Row>
                    <Row>
                      <FormInput name="threats" label="Threats" span={12} />
                    </Row>
                  </fieldset>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Cost" key="cost">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'cost')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Col span={4}>
                    <fieldset>
                      <legend>Penalties</legend>
                      <Row>
                        <FormInput name="penaltyForDelay" label="Penalty for Delay" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="penaltyForDefault" label="Penalty for Default" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="earlyTermination" label="Early Termination" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="maximumPenalty" label="Maximum Penalty" span={12} />
                      </Row>
                    </fieldset>
                  </Col>
                  <Col span={4}>
                    <fieldset>
                      <legend>Expected Yearly Contract Measurement (BRL Million)</legend>
                      <Row>
                        <FormInput name="year1" label="1º Year" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="year2" label="2º Year" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="year3" label="3º Year" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="year4" label="4º Year" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="year5" label="5º Year" span={12} />
                      </Row>
                    </fieldset>
                  </Col>
                  <Col span={4}>
                    <fieldset>
                      <legend>Composition (%)</legend>
                      <Row>
                        <FormInput name="services" label="Services" span={12} />
                      </Row>
                      <Row>
                        <FormInput name="material" label="Material" span={12} />
                      </Row>
                    </fieldset>
                  </Col>
                  <Col span={12}>
                    <Row>
                      <FormTextArea name="others" label="Others" span={12} rows={2} />
                    </Row>
                  </Col>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel header="Governance & Shareholders Approval" key="governanceShareholdersApproval">
              <MasterDetailForm initialValues={data}>
                <Widget
                  actions={[
                    <FormSubmitButton noIcon onClick={values => handleSubmit(values, 'governanceShareholdersApproval')}>
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>,
                  ]}>
                  <Row>
                    <FormSelect
                      options={[
                        { text: 'Medium', value: 'Medium' },
                        { text: 'High', value: 'High' },
                      ]}
                      name="contractScope"
                      label="Contract Scope"
                      span={2}
                    />
                    <FormSelect
                      options={[
                        { text: 'Medium', value: 'Medium' },
                        { text: 'High', value: 'High' },
                      ]}
                      name="exitOptionsClauses"
                      label="Exit Options Clauses"
                      span={2}
                    />
                    <FormSelect
                      options={[
                        { text: 'Medium', value: 'Medium' },
                        { text: 'High', value: 'High' },
                      ]}
                      name="conflictOfInterest"
                      label="Conflict of Interest"
                      span={2}
                    />
                    <FormSelect
                      options={[
                        { text: 'Medium', value: 'Medium' },
                        { text: 'High', value: 'High' },
                      ]}
                      name="biddingProcess"
                      label="Bidding Process"
                      span={2}
                    />
                    <FormInput name="cciContractComplexityIndex" label="CCI - Contract Complexity Index" span={4} />
                  </Row>
                  <Row>
                    <FormInput name="bodApprovalRoute" label="BoD Approval Route" span={4} />
                    <FormInput name="approvalPeriod" label="Approval Period" span={4} />
                    <FormInput name="additionalClarifications" label="Additional clarifications" span={4} />
                  </Row>
                  <Row>
                    <FormTextArea name="supportingDocuments" label="Supporting Documents" span={12} rows={2} />
                  </Row>
                  <Row>
                    <FormTextArea name="compliance" label="Compliance" span={12} rows={2} />
                  </Row>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default SumarioExecutivo;
